import { useDisclosure } from '@chakra-ui/react';
import { IQuoteRespSchema, QuoteStatusEnum } from '@monetize/types/app';
import React, { FunctionComponent as FC } from 'react';
import {
  QUOTE_AFTER_SENT_STATUSES,
  QUOTE_DISABLED_STATUSES,
} from '../../../constants/quotes';
import { QuoteProgressStep } from './QuoteProgressStep';

interface QuoteStepCustomerProps {
  quote: IQuoteRespSchema;
}

export const QuoteStepCustomer: FC<QuoteStepCustomerProps> = React.forwardRef<
  any,
  QuoteStepCustomerProps
>(({ quote }: QuoteStepCustomerProps, ref) => {
  let stepTitle = 'Send to Customer';
  let stepDate: string | null = null;
  const isCompleted =
    QUOTE_AFTER_SENT_STATUSES.has(quote.status) &&
    (!!quote.sentDate || !!quote.acceptedAt);
  const showInprogressStepNumber = false;
  const isCurrent = quote.status === QuoteStatusEnum.APPROVED;
  const isDisabled =
    !isCurrent && QUOTE_DISABLED_STATUSES.has(QuoteStatusEnum.REVIEW);

  if (isCompleted) {
    stepDate = quote.sentDate;
    stepTitle =
      quote.autoRenewal || !quote.requiresEsign
        ? 'Marked as Sent'
        : 'Sent to Customer';
  }
  const popoverState = useDisclosure();

  return (
    <QuoteProgressStep
      key="quote-progress-customer"
      stepTitle={stepTitle}
      stepDate={stepDate}
      stepNumber={3}
      isCompleted={isCompleted}
      showInprogressStepNumber={showInprogressStepNumber}
      isDisabled={isDisabled}
      isCurrent={isCurrent}
      containerProps={{ ml: -8 }}
      popoverState={popoverState}
    />
  );
});
